module.exports = __webpack_public_path__ + "img/bg-2.ce2ddb45.jpg";